import React from 'react';

export const PRESET_AVATARS = [
  '🐱', '🐶', '🦊', '🐻', '🐼',
  '🐸', '🦁', '🐯', '🐨', '🐰',
  '🦄', '🐙', '🦋', '🐝', '🦉',
  '🐳', '🦈', '🐢', '🌸', '⚡'
];

interface UserAvatarProps {
  avatar?: string | null;
  name: string;
  size?: number;
  className?: string;
}

export const UserAvatar = ({ avatar, name, size = 34, className = '' }: UserAvatarProps) => {
  const initials = name
    ? name.includes('@')
      ? name.split('@')[0].slice(0, 2).toUpperCase()
      : name.slice(0, 2).toUpperCase()
    : '?';

  const isEmoji = avatar && PRESET_AVATARS.includes(avatar);
  const isUrl = avatar && !isEmoji;

  return (
    <span
      className={`rounded-full flex items-center justify-center flex-shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      {isUrl ? (
        <img
          src={avatar}
          alt={name}
          className="w-full h-full rounded-full object-cover"
        />
      ) : isEmoji ? (
        <span
          className="flex items-center justify-center w-full h-full rounded-full bg-[#EFEFF1]"
          style={{ fontSize: size * 0.55 }}
        >
          {avatar}
        </span>
      ) : (
        <span
          className="flex items-center justify-center w-full h-full rounded-full bg-[#1D1D1E] text-white font-bold uppercase"
          style={{ fontSize: size * 0.35 }}
        >
          {initials}
        </span>
      )}
    </span>
  );
};
